<section class="modal modal--{{modalData.type}}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="flex-always flex--space-between">
          <p class="modal-title">{{modalData.title}}</p>
          <a href="javascript:void(0);" class="modal-close" (click)="close($event)">{{modalData.cancelButtonText ? modalData.cancelButtonText : 'Cancel'}}<i class="icon">cross</i></a>
        </div>
      </div>
      <div class="modal-body">

        <form id="reactQuote" name="reactQuote">
          <!-- <div id="portr-booking-pod" [attr.data-config]="reactDataConfigString"></div> -->
          <div id="portr-booking-pod" data-config='{}'></div>
          <input type="hidden" name="selectedLanguage" value="{{selectedLanguageCode}}" id="quote-selected-language" />
          <input type="hidden"
            name="submittedData"
            id="quote-submitted-data" />
        </form>

      </div>
    </div>
  </div>
</section>
